import { useForm, useFormState } from "react-hook-form";

import Validations from "@helpers/validations";
import { object } from "yup";
import useAxios from "@hooks/use-axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    name       : "",
    description: "",
    attribute  : "",
    best_value : 0,
    worst_value: 0,
    impact     : "",
    timeframe  : 0,
    type       : ""
};

const useUpsert = props => {

    const {
        handleModalConfig,
        getHealthScores,
        modalConfig: { row },
        isEdit
    } = props;
    const { platformId } = useParams();    
    const { loading, axiosInstance } = useAxios({
        base: "panel"
    });
    const { requiredValidation, numberValidation } = Validations();
    const validationSchema = object().shape({
        name       : requiredValidation({ name: "Name" }),
        description: requiredValidation({ name: "Description" }),
        attribute  : requiredValidation({ name: "Attribute" }),
        type       : requiredValidation({ name: "Type" }),
        timeframe  : numberValidation({ name: "Timeframe", min: 0 }),
        best_value : numberValidation({ name: "Best Value", min: 1 }),
        worst_value: numberValidation({ name: "Worst Value", min: 0 }),
        impact     : requiredValidation({ name: "Impact" })
    });

    const methods = useForm({
        defaultValues,
        resolver: yupResolver(validationSchema)
    });

    const { control, handleSubmit, reset } = methods;
    const { isDirty } = useFormState({ control });

    useEffect(() => {
        let isActive = true;
        if (isEdit && row._id && isActive) {
            reset({
                name       : row.name,
                description: row.description,
                attribute  : row.attribute,
                type       : row.type,
                timeframe  : row.timeframe,
                best_value : row.best_value,
                worst_value: row.worst_value,
                impact     : row.impact
            });
        } else {
            reset(defaultValues);
        }
        return () => {
            isActive = false;
        };
    }, [isEdit, row]);

    const onSubmit = () => {
        handleSubmit(async data => {
            const payload = {
                name       : data.name,
                description: data.description,
                attribute  : data.attribute,
                type       : data.type,
                timeframe  : Number(data.timeframe),
                best_value : Number(data.best_value),
                worst_value: Number(data.worst_value),
                impact     : data.impact

            };

            if (row._id) {
                await axiosInstance.patch(
                    `/health-scores/${platformId}/${row._id}`,
                    payload
                );
            } else {
                await axiosInstance.post(`/health-scores/${platformId}`, payload);
            }
            handleModalConfig();
            getHealthScores();
        })();
    };

    return {
        onSubmit,
        methods,
        updateLoading: loading,
        isDirty
    };
};

export default useUpsert;
